(function ($) {
  $(document).ready(function () {
    $('.faq_q').on("click", function(){
      $(this).next().slideToggle(300);
    });

    $('.yearArchiveList li').on("click", function(){
      $(this).find('.year').toggleClass('open');
      $(this).find('.eachYear').slideToggle(300);
    });
  });
})(jQuery);